import { memo, useState, useEffect } from "react";
import { useCommonStyles } from '../../styles/GenericStyle';
import { Stepper, Step, StepLabel, Typography, Box, Button, Divider } from '@mui/material';
import type { StepIconProps } from '@mui/material/StepIcon';
import { black } from '../../colors';
import { Stack } from "@mui/system";
import TaskAltSharpIcon from '@mui/icons-material/TaskAltSharp';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import SpLotProcessingStage from './StepsIns';
import SkipNextOutlinedIcon from '@mui/icons-material/SkipNextOutlined';
import SPLotProcessingSteps from './SpLotProcessPopup';
import ScannerModal from './ScannerModal';
import { useGlobalState } from "../../contexts/GlobalState";
import { GenericConstant } from "../../utils/GenericConstant";
import { neutralDarkGray } from "../../colors";
import { ConnectorTouchingIcon } from './Connector';
import { MtComStyleObj } from '../../styles/MtComStyleObj';
import { DrawCircle } from '../../components/AvtarIcon';
import { useBeginProcessing } from '../../api/vegApl/Technician';
import { useSnackbar } from '../../contexts/SnackbarContext';
import { validateEquipment } from './equipmentValidation';
import type { SplotStepEquipment } from '../../api/vegApl/SPLotModel';
import FullScreenActionLoader from '../common/FullScreenActionLoader';
import CleaningSkipConfirmDialog from '../common/CleaningSkipConfirmDialog';

export type Step = {
    isShowCommentBox?: boolean,
    protocol_step_id: number,
    protocol_step_instruction: string,
    protocol_step_name: string,
    workflow_step_comment: string,
    workflow_step_status: string,
    treatment_required?: boolean,
    equipments?: SplotStepEquipment[],
}

export type SPLotWorkflowStepStatus = {
    current_protocol_step_id?: number,
    current_protocol_step_status?: string,
    current_protocol_step_name?: string,
    current_workflow_protocol_id?: number,
    resource_id_required?: boolean,
    treatment_required?: boolean,
    equipments?: SplotStepEquipment[],
    mapped_treatments?: string[],
}
export type steeperProps = {
    stArray: Step[],
    SPLotWorkflowSteps: SPLotWorkflowStepStatus,
    status: any,
    drillDownParam: any,
    setRefreshDrillDown: (val: boolean) => void,
    showArchivedSPLots: boolean

}
function SteeperIcon(props: StepIconProps & { status?: any, SPLotWorkflowSteps: any }) {
    const { icon, status, SPLotWorkflowSteps } = props;
    // const classes = useCommonStyles();
    let stepStatus = status?.workflow_step_status?.toLowerCase();
    let currentStepId = SPLotWorkflowSteps?.current_protocol_step_id;
    let currentStepStatus = SPLotWorkflowSteps?.current_protocol_step_status;
    let stepId = status?.protocol_step_id;

    if (stepStatus == GenericConstant.WORKFLOWCOMPLETED) {    
        return <DrawCircle imageWidth={20} backGround={'#00AC4F'} border={false} image={"steeper-icon/done_icon.svg"} />
     
    } else if (stepStatus == GenericConstant.WORKFLOWPROGRESS) {
        return <DrawCircle backGround="white" border={true} borderColor={"#FE9A00"} borderWidth={6} imageWidth={12} image={"steeper-icon/in_progress_icon.svg"} />
       
    }
    else if (stepStatus == GenericConstant.WORKFLOWSKIP) {
        return <DrawCircle imageWidth={18} backGround={'error.main'} image={"steeper-icon/close_icon.svg"} />
      
    }
    if (stepStatus == GenericConstant.WORKFLOWNOTSTARTED) {
        if (currentStepId == stepId && stepStatus?.toLowerCase() == currentStepStatus?.toLowerCase()) {          
            return <DrawCircle border={true} backGround="white" borderColor={"#808080"} borderWidth={5} image={"steeper-icon/up_next_icon.svg"} />
        }
        else {
            return <DrawCircle border={true} innerImage={false} backGround="white" borderColor={"#808080"} borderWidth={5} image={""} content={""} />    
        }

    }

    return (
        <span>
            {icon ?? ""}
        </span>
    );
}
function StepperCom({ stArray, SPLotWorkflowSteps, drillDownParam, setRefreshDrillDown, showArchivedSPLots }: steeperProps) {
    const classes = useCommonStyles();
    const [isShowNotes, setIsShowNotes] = useState(false);
    const [spLotPopType, setSpLotPopType] = useState("");
    const [isOpenCommentPopop, setIsOpenCommentPopop] = useState(false);
    const { state: { roleSelected = "" }, state: globalState } = useGlobalState();
    const { showSnackbar } = useSnackbar();
    const [stepArray, setStepArray] = useState<Step[]>([]);
    const [isBeginProcessingLoading, setIsBeginProcessingLoading] = useState(false);
    const [openEquipmentDialog, setOpenEquipmentDialog] = useState(false);
    const [equipmentInputKey, setEquipmentInputKey] = useState(0);
    const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);
    const [treatmentInputKey, setTreatmentInputKey] = useState(0);
    const [equipmentInput, setEquipmentInput] = useState('');
    const [equipmentError, setEquipmentError] = useState('');
    const [validatedEquipmentId, setValidatedEquipmentId] = useState('');
    const [treatmentInput, setTreatmentInput] = useState('');
    const [treatmentError, setTreatmentError] = useState('');
    const [showSkipCleaningConfirm, setShowSkipCleaningConfirm] = useState(false);
    const [skipCleaningReason, setSkipCleaningReason] = useState('');

    const openCommentPopop = (type: string) => {
        setSpLotPopType(type);
        setIsOpenCommentPopop(true)
    }
    const [actStep, setActiveStep] = useState(0);
    // Check if all steps are completed
    const allStepsCompleted = stepArray.every(step =>
        step?.workflow_step_status?.toLowerCase() === GenericConstant.WORKFLOWCOMPLETED.toLowerCase() || step?.workflow_step_status?.toLowerCase() === GenericConstant.WORKFLOWSKIP.toLowerCase()
    );

    useEffect(() => {
        setStepArray(stArray);
        const actualStep = stArray.findIndex((ele) => ele?.protocol_step_id === SPLotWorkflowSteps?.current_protocol_step_id);
        if (SPLotWorkflowSteps?.current_protocol_step_id === stArray?.[stArray.length - 1]?.protocol_step_id) {
            setActiveStep(actualStep + 2);
        }
        else {
            setActiveStep(actualStep >= 0 ? actualStep : 0);
        }

    }, [stArray, SPLotWorkflowSteps]);

    const { mutate: beginProcessingWithoutResource } = useBeginProcessing({
        mutation: {
            onSuccess: (_: any) => {
                //showSnackbar({ message: data?.data?.message, severity: 'success' });
                setIsBeginProcessingLoading(false);
                setRefreshDrillDown(true);
            },
            onError: (error: any) => {
                const detail = error?.response?.data?.detail;
                const errorMessage = typeof detail === 'string' ? detail : 'Error in processing SPLot';
                showSnackbar({ message: errorMessage, severity: 'error' });
                setIsBeginProcessingLoading(false);
            },
        },
    });

    const getCurrentStep = (): Step | undefined => {
        const currentStepId = Number(SPLotWorkflowSteps?.current_protocol_step_id);
        if (!currentStepId) return undefined;
        return stepArray.find((step: Step) => Number(step?.protocol_step_id) === currentStepId);
    };

    const getStepEquipments = (): SplotStepEquipment[] => {
        const currentStep = getCurrentStep();
        return Array.isArray(currentStep?.equipments) ? currentStep.equipments : [];
    };

    const getMappedEquipmentDisplayName = (inputValue: string): string => {
        const normalizedInput = String(inputValue ?? '').trim().toLowerCase();
        if (!normalizedInput) return '';

        const matchedEquipment = getStepEquipments().find(
            (equipment: SplotStepEquipment) => String(equipment?.equipment_id ?? '').trim().toLowerCase() === normalizedInput
        );

        const mappedName = (matchedEquipment as (SplotStepEquipment & { display_name?: string }) | undefined)?.display_name;
        return String(mappedName ?? '');
    };

    const mappedEquipmentDisplayName = getMappedEquipmentDisplayName(equipmentInput);

    const isCurrentStepEquipmentMandatory = (): boolean => {
        const equipments = getStepEquipments();
        if (equipments.length === 0) return false;
        // Treat missing flag as mandatory unless explicitly marked false.
        return equipments.some((equipment: SplotStepEquipment) => equipment?.is_mandatory !== false);
    };

    const isCurrentStepEquipmentOptional = (): boolean => {
        const equipments = getStepEquipments();
        return equipments.length > 0 && !isCurrentStepEquipmentMandatory();
    };

    const isCurrentStepTreatmentRequired = (): boolean => {
        const currentStep = getCurrentStep();
        return Boolean(currentStep?.treatment_required);
    };

    const isCurrentStepCleaning = (): boolean => {
        const currentStep = getCurrentStep();
        return String(currentStep?.protocol_step_name ?? '').trim().toLowerCase().includes('clean');
    };

    const startBeginProcessing = (payload?: { equipment_id?: string; treatment_name?: string; skip_reason?: string }) => {
        const splotId = drillDownParam?.splot_id;
        const userId = globalState?.user_id_db;
        const workflowStepId = SPLotWorkflowSteps?.current_protocol_step_id;
        const workflowProtocolId = SPLotWorkflowSteps?.current_workflow_protocol_id;

        if (!splotId || !userId || !workflowStepId || !workflowProtocolId) {
            showSnackbar({ message: 'Unable to begin processing: missing workflow context', severity: 'error' });
            return;
        }

        const req: any = {
            comment: "",
            splot_ids: [splotId],
            user_id: userId,
            workflow_step_id: workflowStepId,
            workflow_protocol_id: workflowProtocolId,
            equipment_id: ""
        };

        if (payload?.equipment_id) {
            req.equipment_id = payload.equipment_id;
        }
        if (payload?.treatment_name) {
            req.treatment_name = payload.treatment_name;
        }
        if (payload?.skip_reason) {
            req.skip_reason = payload.skip_reason;
        }

        setIsBeginProcessingLoading(true);
        beginProcessingWithoutResource({ data: req });
    };

    const handleValidateEquipment = () => {
        const equipments = getStepEquipments();

        if (equipments.length === 0) {
            setOpenEquipmentDialog(false);
            if (isCurrentStepTreatmentRequired()) {
                setTreatmentInput('');
                setTreatmentError('');
                setOpenTreatmentDialog(true);
                return;
            }
            startBeginProcessing();
            return;
        }

        const validation = validateEquipment(equipmentInput, equipments);

        if (!validation.valid) {
            setEquipmentInput('');
            setEquipmentError(validation.error || 'Please enter a valid equipment ID');
            setEquipmentInputKey(k => k + 1);
            return;
        }

        setValidatedEquipmentId(validation.equipmentId || '');
        setEquipmentError('');
        setOpenEquipmentDialog(false);

        if (isCurrentStepTreatmentRequired()) {
            setOpenTreatmentDialog(true);
            return;
        }

        startBeginProcessing({ equipment_id: validation.equipmentId });
    };

    const proceedSkipEquipment = () => {
        setOpenEquipmentDialog(false);
        setEquipmentInput('');
        setEquipmentError('');
        setValidatedEquipmentId('');

        if (isCurrentStepCleaning()) {
            setSkipCleaningReason('');
            setShowSkipCleaningConfirm(true);
            return;
        }

        const isResourceIdRequired = Boolean(SPLotWorkflowSteps?.resource_id_required);
        if (isResourceIdRequired) {
            openCommentPopop("beginProcess");
            return;
        }

        if (isCurrentStepTreatmentRequired()) {
            setTreatmentInput('');
            setTreatmentError('');
            setOpenTreatmentDialog(true);
            return;
        }

        startBeginProcessing();
    };

    const handleConfirmSkipCleaning = () => {
        setShowSkipCleaningConfirm(false);
        startBeginProcessing({ skip_reason: skipCleaningReason || undefined });
        setSkipCleaningReason('');
    };

    const handleValidateTreatment = () => {
        const treatment = treatmentInput.trim();
        if (!treatment) {
            setTreatmentError('Treatment ID is required');
            return;
        }

        const mappedTreatments = Array.isArray(SPLotWorkflowSteps?.mapped_treatments)
            ? SPLotWorkflowSteps.mapped_treatments
            : [];

        if (mappedTreatments.length > 0) {
            const isValidTreatment = mappedTreatments.some(
                (mappedTreatment) => String(mappedTreatment ?? '').trim().toLowerCase() === treatment.toLowerCase()
            );

            if (!isValidTreatment) {
                setTreatmentError(`Invalid treatment. Expected: ${mappedTreatments.join(', ')}`);
                setTreatmentInput('');
                setTreatmentInputKey(k => k + 1);
                return;
            }
        }

        const hasEquipments = getStepEquipments().length > 0;
        const requireEquipmentValidation = hasEquipments && isCurrentStepEquipmentMandatory();

        if (requireEquipmentValidation && !validatedEquipmentId) {
            setTreatmentError('Equipment validation is required before treatment');
            setOpenTreatmentDialog(false);
            setOpenEquipmentDialog(true);
            return;
        }

        setTreatmentError('');
        setOpenTreatmentDialog(false);
        startBeginProcessing({
            equipment_id: hasEquipments ? validatedEquipmentId : undefined,
            treatment_name: treatment,
        });
    };

    const handleBeginProcessing = () => {
        const hasEquipments = getStepEquipments().length > 0;

        setEquipmentInput('');
        setEquipmentError('');
        setValidatedEquipmentId('');
        setTreatmentInput('');
        setTreatmentError('');

        if (!hasEquipments) {
            const isResourceIdRequired = Boolean(SPLotWorkflowSteps?.resource_id_required);
            if (isResourceIdRequired) {
                openCommentPopop("beginProcess");
                return;
            }

            if (isCurrentStepTreatmentRequired()) {
                setOpenTreatmentDialog(true);
                return;
            }

            startBeginProcessing();
            return;
        }

        setOpenEquipmentDialog(true);
    };

    return (
        <>
            <FullScreenActionLoader open={isBeginProcessingLoading} />
            <Box sx={{ mt: 2 }}>
                <Box display={"flex"} justifyContent={"space-between"} sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 1, sm: 0 } }}>
                        <Box className={classes.processingStepsLabel}>
                            Processing Steps
                        </Box>
                        <Stack direction="row" gap={{ xs: 1, sm: 2 }} alignItems="center" flexWrap="wrap">
                            <Typography display="flex" alignItems="center" component="div" className={classes.labelNoto12Bold400} color="text.secondary">

                                <DrawCircle size={20} imageWidth={10} backGround={'#00AC4F'} border={false} image={"steeper-icon/done_icon.svg"} />
                                <Typography component="span" color="#4A5565" sx={{ ml: 0.5 }} className={classes.labelNoto12Bold400}>Completed</Typography>
                            </Typography>
                            <Typography display="flex" alignItems="center" className={classes.labelNoto12Bold400} component="div" color="text.secondary">

                                <DrawCircle size={20} imageWidth={10} backGround="white" border={true} borderColor={"#FE9A00"} borderWidth={3} image={"steeper-icon/in_progress_icon.svg"} />
                                <Typography component="span" color="#4A5565" sx={{ ml: 0.5 }} className={classes.labelNoto12Bold400}>In Progress</Typography>
                            </Typography>
                            <Typography display="flex" alignItems="center" className={classes.labelNoto12Bold400} component="div" color="text.secondary">

                                <DrawCircle size={20} imageWidth={13} backGround={'error.main'} image={"steeper-icon/close_icon.svg"} />
                                <Typography component="span" color="#4A5565" sx={{ ml: 0.5 }} className={classes.labelNoto12Bold400}>Skipped</Typography>
                            </Typography>
                            <Typography display="flex" alignItems="center" className={classes.labelNoto12Bold400} component="div" color="text.secondary">

                                <DrawCircle size={20} imageWidth={10} border={true} backGround="white" borderColor={"#808080"} borderWidth={3} image={"steeper-icon/up_next_icon.svg"} />
                                <Typography component="span" color="#4A5565" sx={{ ml: 0.5 }} className={classes.labelNoto12Bold400}>Up Next</Typography>

                            </Typography>
                            <Typography display="flex" alignItems="center" component="div" color="text.secondary">

                                <DrawCircle size={20} border={true} innerImage={false} backGround="white" borderColor={"#808080"} borderWidth={4} />
                                <Typography component="span" color="#4A5565" sx={{ ml: 0.5 }} className={classes.labelNoto12Bold400}>Pending </Typography>


                            </Typography>
                        </Stack>

                    </Box>

                    <Box sx={{ mt: { xs: '16px', sm: '31px' }, overflowX: 'auto' }}>
                        <Stepper activeStep={actStep} alternativeLabel connector={<ConnectorTouchingIcon />} sx={{

                            "& .MuiStepConnector-line": {
                                borderTopWidth: "4px",
                            },
                            "& .MuiStepConnector-root .MuiStepConnector-line": {
                                borderColor: "grey.400",
                            },
                        }}>
                            {stepArray?.map((step: any) => (
                                <Step key={step?.protocol_step_name} >
                                    <StepLabel
                                        slots={{
                                            stepIcon: (p: StepIconProps) => <SteeperIcon {...p} status={step} SPLotWorkflowSteps={SPLotWorkflowSteps} />,
                                        }}
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: 14,
                                                fontWeight: 500,
                                                letterSpacing: "0.15px",
                                                color: neutralDarkGray
                                            },
                                            '&.not-started .MuiStepLabel-label': {
                                                color: neutralDarkGray
                                            },
                                            '&.Skipped .MuiStepLabel-label': {
                                                color: "error.main"
                                            },
                                            '&.Completed .MuiStepLabel-label': {
                                                color: "#00A63E"
                                            },

                                        }}
                                        className={(step?.workflow_step_status ?? "").split(" ").join("-")}>{step?.protocol_step_name ?? ""}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </Box>
                    <Divider sx={{
                        mt: { xs: '20px', sm: '43px' },
                        borderColor: black
                    }} />
                    <Box sx={{ mt: "10px", width: '100%' }}>
                        {!showArchivedSPLots && <Stack direction={"row"} gap={2} flexWrap="wrap">
                            <Button variant="contained" disableRipple startIcon={<TaskAltSharpIcon />} onClick={() => openCommentPopop("markAsDone")} className={classes.greenButton}
                                sx={(theme) => ({
                                    marginTop: 3,
                                    padding: "10px 12px"
                                    , ...MtComStyleObj(theme).disabledGreenBtnStyle
                                })}
                                disabled={SPLotWorkflowSteps?.current_protocol_step_status?.toLowerCase() != GenericConstant.WORKFLOWPROGRESS || ["Breeder"].includes(roleSelected) || [9,10].includes(Number(SPLotWorkflowSteps?.current_protocol_step_id)) }>
                                Mark as Done</Button>
                            <Button variant="contained" disableRipple startIcon={<PlayArrowIcon />} onClick={handleBeginProcessing} className={classes.blueButton}
                                disabled={SPLotWorkflowSteps?.current_protocol_step_status?.toLowerCase() != GenericConstant.WORKFLOWNOTSTARTED || ["Breeder"].includes(roleSelected) || isBeginProcessingLoading   || [9,10].includes(Number(SPLotWorkflowSteps?.current_protocol_step_id)) }
                                sx={(theme) => ({
                                    marginTop: 3, padding: "10px 12px",
                                    ...MtComStyleObj(theme).disabledGreenBtnStyle
                                })}  loading={isBeginProcessingLoading} loadingPosition="start" >
                               Begin processing
                    
                            </Button>
                            <Button disableRipple variant="contained"
                                disabled={!["S2S-Lead", "Admin","Technician"].includes(roleSelected) ||  [9,10].includes(Number(SPLotWorkflowSteps?.current_protocol_step_id)) || SPLotWorkflowSteps?.current_protocol_step_id === 10 || allStepsCompleted || !SPLotWorkflowSteps?.current_protocol_step_status?.toLowerCase()}
                                startIcon={<SkipNextOutlinedIcon />} onClick={() => openCommentPopop("skip")} className={classes.redBorderRedLabel}
                                sx={(theme) => ({
                                    marginTop: 3, padding: "10px 12px",
                                    ...MtComStyleObj(theme).disabledRedBtnStyle
                                })}

                            >Skip Step</Button>
                        </Stack>}

                        <Stack direction="row" gap={1} sx={{ display: "flex", width: '100%', alignItems: 'center', cursor: "pointer", mt: { xs: '16px', sm: '30px' } }} onClick={() => setIsShowNotes(prev => !prev)}>
                            {!isShowNotes ? <KeyboardArrowDownOutlinedIcon sx={{ fontSize: 16 }} /> : <KeyboardArrowUpOutlinedIcon sx={{ cursor: "pointer", fontSize: 16 }} />}
                            <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 16 }} />
                            <Typography
                                component="span"
                                color="#364153"
                                sx={{ flex: 1 }} className={classes.labelNoto15Bold500}>
                                {isShowNotes ? 'Hide' : 'Show'}  Step Instructions
                            </Typography>
                        </Stack>
                        <Divider sx={{
                            mt: { xs: '16px', sm: '30px' },
                            borderColor: black
                        }} />
                        {isShowNotes && <SpLotProcessingStage stepsData={stepArray} drillDownParam={drillDownParam} SPLotWorkflowSteps={SPLotWorkflowSteps} setIsRefreshDrillDown={setRefreshDrillDown} />}
                    </Box>
            </Box>
            <Box sx={{ mb: 3 }} />

            <ScannerModal
                open={openEquipmentDialog}
                inputKey={equipmentInputKey}
                title="Scan Equipment ID"
                label="Equipment ID"
                placeholder="Enter or scan equipment id"
                value={equipmentInput}
                error={equipmentError}
                mappedValueText={mappedEquipmentDisplayName ? `Equipment Name: ${mappedEquipmentDisplayName}` : ''}
                showInput
                infoText="No equipment configured for this step. You can skip equipment validation."
                primaryButtonText={isCurrentStepEquipmentMandatory() ? 'Validate' : 'Validate'}
                secondaryButtonText={isCurrentStepEquipmentOptional() ? 'Skip' : undefined}
                secondaryButtonStartIcon={isCurrentStepEquipmentOptional() ? <SkipNextOutlinedIcon /> : undefined}
                onClose={() => setOpenEquipmentDialog(false)}
                onChange={setEquipmentInput}
                onValidate={handleValidateEquipment}
                onSecondaryAction={isCurrentStepEquipmentOptional() ? proceedSkipEquipment : undefined}
                onEnterPress={handleValidateEquipment}
            />

            <ScannerModal
                open={openTreatmentDialog}
                inputKey={treatmentInputKey}
                title="Scan Treatment"
                label="Treatment ID"
                placeholder="Enter or scan treatment"
                value={treatmentInput}
                error={treatmentError}
                onClose={() => setOpenTreatmentDialog(false)}
                onChange={setTreatmentInput}
                onValidate={handleValidateTreatment}
                onEnterPress={handleValidateTreatment}
            />

            <CleaningSkipConfirmDialog
                open={showSkipCleaningConfirm}
                reason={skipCleaningReason}
                onReasonChange={setSkipCleaningReason}
                onCancel={() => {
                    setShowSkipCleaningConfirm(false);
                    setSkipCleaningReason('');
                    setOpenEquipmentDialog(true);
                }}
                onConfirm={handleConfirmSkipCleaning}
            />
            <SPLotProcessingSteps openAddEditMatModal={isOpenCommentPopop} type={spLotPopType} setIsOpenCommentPopop={setIsOpenCommentPopop} drillDownParam={drillDownParam} SPLotWorkflowSteps={SPLotWorkflowSteps} setIsRefreshDrillDown={setRefreshDrillDown} />
        </>
    );
}
export default memo(StepperCom);
